import React from "react";
import SlidingPuzzle from "./SlidingPuzzle";
import MiniSudoku from "./MiniSudoku";
import MemoryGame from "./MemoryGame";

function MiniGames({ canPlay, onWinMoney, currentRound }) {
  return (
    <div style={{ display: "grid", gap: 8 }}>
      <MiniSudoku 
        canPlay={canPlay} 
        onWin={() => onWinMoney(5, "Sudoku")} 
      />
      <SlidingPuzzle
        canPlay={canPlay}
        onWin={() => onWinMoney(5, "Rompecabezas")}
      />
      <MemoryGame
        canPlay={canPlay}
        onWin={() => onWinMoney(5, "Memory")}
        currentRound={currentRound}
      />
    </div>
  );
}

export default MiniGames;
